var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PyJob_1;
import { JsonSchema, JSON, JsonConverter, DateConverter } from '@symon-ai/wisepipe-serialize';
import { Job } from './job';
export var PyJobStatus;
(function (PyJobStatus) {
    PyJobStatus["QUEUED"] = "queued";
    PyJobStatus["RUNNING"] = "running";
    PyJobStatus["COMPLETED"] = "completed";
    PyJobStatus["FAILED"] = "failed";
    PyJobStatus["TIMEOUT"] = "timeout";
    PyJobStatus["EXPIRED"] = "expired";
})(PyJobStatus || (PyJobStatus = {}));
const schema = {
    $id: 'urn:wisepipe-python-job-domain:PyJob',
    type: 'object',
    properties: {
        jobID: { type: 'string', minLength: 1, maxLength: 200 },
        status: { type: 'string', enum: Object.values(PyJobStatus) },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        maxProgressIncrement: { type: 'number', minimum: 0 },
        currentProgressIncrement: { type: 'number', minimum: 0 },
        uniqueID: { type: 'string' },
        end: { type: 'string', format: 'date-time' },
        pyStart: { type: 'string', format: 'date-time' },
        runtime: { type: 'number', minimum: 0 },
        result: { type: ['object', 'array', 'string', 'number', 'boolean', 'null'] },
        error: { type: 'string' },
        stdout: { type: 'string' },
        stderr: { type: 'string' }
    },
    // status determines required fields
    if: { properties: { status: { const: PyJobStatus.COMPLETED } }, required: ['status'] },
    then: { required: ['runtime', 'result', 'end'] },
    else: {
        if: { properties: { status: { const: PyJobStatus.FAILED } }, required: ['status'] },
        then: { required: ['error', 'end'] }
    },
    required: ['jobID', 'status', 'progress']
};
let PyJob = PyJob_1 = class PyJob extends Job {
    constructor(jobID, status, progress, start, end, pyStart, runtime, result, error, stdout, stderr, maxProgressIncrement, currentProgressIncrement, uniqueID) {
        super(jobID, start);
        this.status = status;
        this.progress = progress;
        if (end !== undefined)
            this.end = end;
        if (pyStart !== undefined)
            this.pyStart = pyStart;
        if (runtime !== undefined)
            this.runtime = runtime;
        if (result !== undefined)
            this.result = result;
        if (error !== undefined)
            this.error = error;
        if (stdout !== undefined)
            this.stdout = stdout;
        if (stderr !== undefined)
            this.stderr = stderr;
        this.maxProgressIncrement = maxProgressIncrement;
        this.currentProgressIncrement = currentProgressIncrement;
        this.uniqueID = uniqueID;
        JSON.validate(this, PyJob_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], PyJob.prototype, "end", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], PyJob.prototype, "pyStart", void 0);
PyJob = PyJob_1 = __decorate([
    JsonSchema(schema)
], PyJob);
export { PyJob };
//# sourceMappingURL=pyJob.js.map